import { createContext } from 'react';
import { ProfileOnboardingContextValue } from './interfaces';

export const ProfileOnboardingContext = createContext<ProfileOnboardingContextValue>({
  back:          () => {},
  next:          () => {},
  saveBio:       () => {},
});